<template>
  <div class="group-detail">
    <h1 class="common__main-title">Booth import</h1>
    <div class="common__sub-title">Import</div>
    <div class="common__main-contener">
      <div class="common__main-content">
        <div>
          <h3 class="common__search-title">booth csv</h3>
          <FileInput v-model="selectedCsv" />
          <ErrorCsv :errorMessages="errorMessages" />
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <b-button
          pill
          variant="secondary"
          :to="{name:'Booths'}"
        >
          Back
        </b-button>
        <b-button
          pill
          variant="primary"
          @click="confirmUploadCsv"
        >
          Import
        </b-button>
      </div>
    </div>
    <ConfirmModal ref="confirmModal" isLoadingMode @ok="registerBooths" />
    <SuccessModal ref="sucessModal" @ok="vm.$router.push({name:'Booths'})"/>
  </div>
</template>

<script>
import _ from 'lodash';
import FileInput from '@/components/parts/inputItem/FileInput.vue';
import ConfirmModal from '@/components/parts/modal/Confirm.vue';
import SuccessModal from '@/components/parts/modal/Success.vue';
import ErrorCsv from '@/components/parts/ErrorCsv.vue';

export default {
  created() {
    this.vm = this;
  },

  data() {
    return {
      selectedCsv: null,
      errorMessages: [],
      isReload: false,
      vm: null,
    }
  },

  components: {
    FileInput,
    ConfirmModal,
    SuccessModal,
    ErrorCsv,
  },
  methods: {
    confirmUploadCsv() {
      if (!this.selectedCsv) {
        this.errorMessages = ['required csv file.'];
        return;
      }
      if (this.isReload) return
      this.isReload = false;
      this.errorMessages = [];
      try {
        // 登録数チェック
        this.isReload = true;
        const reader = new FileReader();
        reader.readAsText(this.selectedCsv);
        reader.onload = () => {
          // ヘッダの一行は除いてインポート人数の確認モーダルを表示
          this.isReload = false;
          const recordsCount = _.chain(reader)
            .get('result')
            .split('\n')
            .drop()
            .compact()
            .value()
            .length;

          this.$refs.confirmModal.open(`Import ${recordsCount} booths. Is it OK?`);
        };
        reader.onerror = () => {
          // 読み取り失敗の場合、画面リロード
          this.errorMessages = ['selected file has error. please select file again.'];
          this.selectedCsv = null
        }
      } catch (error) {
        this.setErrors(error);
        this.$refs.confirmModal.close();
      }
    },
    registerBooths() {
      // ブースインポート処理
      const conditions = {};
      const page = 1;
      this.$store.dispatch('importBoothsByCsv', this.selectedCsv)
        .then(() => {
          this.$refs.confirmModal.close();
          this.$store.dispatch('fetchBooths', { conditions, page });
          this.$refs.sucessModal.open();
        })
        .catch((error) => {
          this.setErrors(error);
          this.$refs.confirmModal.close();
        });
    },
    setErrors(error) {
      this.errorMessages = [error];
      if (error.response) {
        let errors = _.chain(error.response)
          .get('data.message').value();
        if (_.some(errors, (o) => _.has(o, 'message'))) {
          errors = errors
            .map(({ index, message }) => `row ${index} booth has error: ${message}`);
        }
        this.errorMessages = Array.isArray(errors) ? errors : [errors];
      }
    },
  },
};

</script>
